import React from 'react';
import { Box, BoxProps, keyframes } from '@mui/material';
import styles from './styles';

const slideLeft = keyframes`
  from {
    transform: translateX(20px);
    opacity: 0.95;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

interface DashboardContainerProps extends BoxProps {
  children: React.ReactNode;
}

function DashboardContainer({ children, ...props }: DashboardContainerProps) {
  return (
    <Box
      sx={{
        ...styles.container,
        margin: '0px',
        backgroundColor: 'secondary.main',
        padding: '0px 20px 10px',
        height: '100vh',
        animation: `${slideLeft} 0.4s ease-out`,
        ...props.sx,
      }}
    >
      {children}
    </Box>
  );
}

export default DashboardContainer;
